var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBottombarProfileActive = function SvgBottombarProfileActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#bottombar-profile-active_svg__a)",
    strokeWidth: 1.5,
    d: "M8.75 6a3.25 3.25 0 1 0 6.5 0 3.25 3.25 0 0 0-6.5 0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#bottombar-profile-active_svg__b)",
    strokeWidth: 1.5,
    d: "M5.75 17c0 1.076.61 2.12 1.736 2.925S10.206 21.25 12 21.25s3.388-.52 4.514-1.325S18.25 18.075 18.25 17c0-1.076-.61-2.12-1.736-2.925S13.794 12.75 12 12.75s-3.388.52-4.514 1.325S5.75 15.925 5.75 17Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bottombar-profile-active_svg__a",
    x1: 12,
    x2: 12,
    y1: 2.75,
    y2: 9.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1967DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#001A9F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bottombar-profile-active_svg__b",
    x1: 12,
    x2: 12,
    y1: 12.75,
    y2: 21.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1967DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#001A9F"
  })))));
};
export default SvgBottombarProfileActive;